import { FC } from "react";
import styles from './CategoryPicker.module.css';
import { CategoryButton } from "./CategoryButton";
import { getIcon } from "../utils/CategoryUtil";
import { useCategories } from "../hooks/useCategories";

interface CategoryPickerProps {
    selectedCategories: string[];
    blue?: boolean;
    maxCategories?: number;
    showAll?: boolean;
    onChange: (categories: string[]) => void;
}

const CategoryPicker: FC<CategoryPickerProps> = ({showAll = true, selectedCategories, blue = false, onChange, maxCategories}) => {

    const {categories} = useCategories();

    const isSelected = (cat: string): boolean => {
        if(cat == "all" && selectedCategories[0] == '') { return true; }
        return selectedCategories.includes(cat);
    };

    const toggleCategory = (catSlug: string): void => {

        let cats: string[] = [];
        if(catSlug == "all") {
            cats = [''];
        }
        else {
            if (isSelected(catSlug)) {
                // If the category is selected, remove it from the array
                cats = selectedCategories.filter((c) => c !== catSlug);
            } else {
                // If the category is not selected, add it to the array
                cats = [...selectedCategories.filter(x => x), catSlug];
            }
            if(maxCategories && cats.length > maxCategories) {
                cats.shift();
            }
        }
        
        onChange(cats);
        
    };

    return (<div className={styles.categoriesContainer}>
        {showAll && <div className={[styles.categoryItem, isSelected("all") ? "selected" : ""].join(' ')} onClick={() => toggleCategory("all")}> 
            <CategoryButton title={"Toutes"} selected={isSelected("all")} image={getIcon("all")} blue={blue}/>
        </div>}
        {categories.map(c =>
                <div 
                key={c.slug}
                className={[styles.categoryItem, isSelected(c.slug) ? "selected" : ""].join(' ')} onClick={() => toggleCategory(c.slug)}> 
                    <CategoryButton title={c.name} selected={isSelected(c.slug)} image={getIcon(c.slug)} blue={blue}/>
                </div>
        )}

    </div>);

}

export default CategoryPicker;